<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/monitorCFLList' }">
					<i class="el-icon-monitor"></i> 视频类别管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加视频类别</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="'所属幼儿园'" prop="cflSAAI">
							<el-select v-model="ruleForm.cflSAAI" clearable filterable :placeholder="'请选择幼儿园'" class="handle-select mr10">
								<el-option v-for="item in ruleForm.optionsSAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'视频类别名称'" prop="cflNAME">
							<el-input v-model="ruleForm.cflNAME" :placeholder="'请输入视频类别名称'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addMonitorCFL',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入视频类别名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkCFLNAME(value);
					if (this.isRepeat == true) {
						callback(new Error('视频类别名称重复'));
					} else {
						callback();
					}
				}
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				
				isRepeat: false,
				ruleForm: {
					cflSAAI: '',
					optionsSAAI: [],
					cflNAME: ''
				},
				rules: {
					cflNAME: [{
						required: true,
						//message: '请输入视频类别名称', //请输入社名称
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					cflSAAI: [{
						required: true,
						message: '请选择幼儿园',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		created() {
			this.getSAAI(); //幼儿园
		},
		methods: {
			//验证此幼儿园下，视频类别名称是否重复
			checkCFLNAME(value) {
				const self_shop = this;
				
				var postUrl = 'WCF/WEB/svcCFL.svc/CHECK_CFL_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.cflSAAI,
						sCFLID: null,
						sCFLNM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取幼儿园信息
			getSAAI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon //web侧 登录邮箱
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsSAAI = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});

				});
			},
			//视频类别新增
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						var postUrl = 'WCF/WEB/svcCFL.svc/ADD_CFL';
						//网络请求接口
						this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
								sCFLSAAI: self.ruleForm.cflSAAI ? self.ruleForm.cflSAAI : '',
								sCFLNAME: self.ruleForm.cflNAME
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;

							if (resStatus == "200") {
								if (resKKSTR == "N") {
									this.$message({
										message: '添加视频类别失败', //新增失败
										type: 'error'
									});
								} else if (resKKSTR == "Y") {
									this.$message.success('添加视频类别成功'); // 新增成功
									this.$router.push('/monitorCFLList') // 跳转路由
									this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload

									var indexs;
									for (let i = 0; i < this.COMM.tagsLists.length; i++) {
										if (this.COMM.tagsLists[i].name == "addMonitorCFL") {
											indexs = i;
											break;
										}
									}

									this.closeTags(indexs);
								}
							} else {
								this.$message({
									message: '添加视频类别请求失败', //请求失败
									type: 'error'
								});
							}
						})
						.catch((error) => {
							this.$message({
								message: '添加视频类别请求失败', //请求失败
								type: 'error'
							});
						});
					} else {
						this.$message({
							message: '提交失败', //表单验证失败
							type: 'error'
						});
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addMonitorCFL") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.font {
		font-size: 14px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 15px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.handle-select-y {
		width: 45%;
	}
</style>
